import React from 'react';
import { Container } from 'react-bootstrap';
import VehicleSectionsNav from '../VehicleSectionsNav';
import VehicleSellForm from './VehicleSellForm';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';

function VehicleSellPage() {
  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Vehicles', url: '/vehicles' },
    { id: 3, type: 'span', text: 'Vehicle sell' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Vehicle Sell" />
      <VehicleSectionsNav section="sell" />
      <VehicleSellForm />
    </Container>
  );
}

export default VehicleSellPage;
